import { WidgetRegistry } from "@Widgets/types";
import { IdentityVerificationModal } from "../Components/IdentityVerificationModal/IdentityVerificationModal";
import { HoursWorkedInput } from "../Components/HoursWorkedInput/HoursWorkedInput";
import { SPRecurrenceModal } from "../Components/SPRecurrenceModal/SPRecurrenceModal";

const serviceProvidersWidgetRegistry: Pick<
  WidgetRegistry,
  | "ServiceProvider.IdentityVerificationModal"
  | "ServiceProvider.HoursWorkedInput"
  | "ServiceProvider.SPRecurrenceModal"
> = {
  "ServiceProvider.IdentityVerificationModal": {
    Component: IdentityVerificationModal,
  },
  "ServiceProvider.HoursWorkedInput": {
    Component: HoursWorkedInput,
  },
  "ServiceProvider.SPRecurrenceModal": {
    Component: SPRecurrenceModal,
  },
};

export default serviceProvidersWidgetRegistry;
